import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'greeting'
})

/**
 * GreetingPipe. Using the current hour of the date passed in, this will return a greeting for morning, afternoon or evening.
 * value parameter is a date object
 *
 * __Usage :__
 *  ```
 *
 *  <h1>{{ 'Hi' | greeting}}</h1>
 *
 */


export class GreetingPipe implements PipeTransform {

  public today: Date = new Date();

  transform(value: any, args?: any): any {
    const currentHour = this.today.getHours();
    if (currentHour < 12) {
      return  'Good morning';
    } else if (currentHour < 18) {
      return 'Good afternoon';
    } else {
      return 'Good evening';
    }
    return value;
  }
}
